import { render, staticRenderFns } from "./LinkMyGroupsDialog.vue?vue&type=template&id=61710546&"
import script from "./LinkMyGroupsDialog.vue?vue&type=script&lang=js&"
export * from "./LinkMyGroupsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports